<template>
  <div id="recruitIncome">
    <div class="recruit__container recruit__income">
      <p class="income__title">원하는 수업 분야를 선택해주세요</p>
      <div class="income__purpose pc">
        <p class="purpose__item" v-for="(p, index) in purposes" :key="index"
          :class="{on: p.value === lessonInfo.purpose}"
          @click="changePurpose(p.value)">{{p.name}}</p>
      </div>
      <div class="income__purpose mo" @click="openPurposeModal">{{computedPurposeText[0].name}} 〉</div>
      <p class="income__title">원하는 하루 수업 횟수를 선택해주세요</p>
      <div class="income__select" @click="openCountModal">{{computedLessonCountText[0].name}}</div>
      <div class="income__purpose mo" @click="openCountModal">{{computedLessonCountText[0].name}} 〉</div>
      <p class="income__price">월 평균 예상 수익 <strong id="totalPrice"></strong>원</p>
      <p class="income__info">
        <b>1인 최소 수업료 기준으로 영업일수를 곱하여 산출한 금액</b>입니다.<br>
        수업 인원에 따라서 수익금에 차이가 있으며, 구체적인 정산금액은 미팅 전 안내해드립니다.
      </p>
    </div>
    <CommonFilterNotButton v-if="isPurposeModal"
      :title="'수업 분야'"
      :items="purposes"
      :selected="lessonInfo.purpose"
      @select-filter="setPurpose"
      @click-backdrop="closePurposeModal" />
    <CommonFilterNotButton v-if="isCountModal"
      :title="'수업 횟수'"
      :items="counts"
      :selected="lessonInfo.count"
      @select-filter="setLessonCount"
      @click-backdrop="closeCountModal" />
  </div>
</template>
<script>
const PURPOSES = [
  {value: 'A', name: '운동'},
  {value: 'D', name: '요가명상'},
  {value: 'H', name: '전문 통증케어'},
];
const COUNTS = [
  {value: 1, name: '1회'},
  {value: 2, name: '2회'},
  {value: 3, name: '3회'},
  {value: 4, name: '4회'},
  {value: 5, name: '5회'},
];
import {get} from 'lodash';
import CommonFilterNotButton from '@/components/common/CommonFilterNotButton';
export default {
  name: 'RecruitIncome',
  components: {
    CommonFilterNotButton,
  },
  props: {
    lessonInfo: {type: Object, default: () => {}}
  },
  data(){
    return{
      purposes: PURPOSES,
      counts: COUNTS,
      isPurposeModal: false,
      isCountModal: false,
    }
  },
  computed: {
    computedPurposeText(){
      return this.purposes.filter(p => get(p, 'value') === this.lessonInfo.purpose)
    },
    computedLessonCountText(){
      return this.counts.filter(c => get(c, 'value') === this.lessonInfo.count)
    }
  },
  methods:{
    setPurpose(val){
      this.$emit('set-purpose', val)
    },
    setLessonCount(val){
      this.$emit('set-lesson-count', val)
    },
    openPurposeModal(){
      this.isPurposeModal = true
    },
    closePurposeModal(){
      this.isPurposeModal = false
    },
    openCountModal(){
      this.isCountModal = true
    },
    closeCountModal(){
      this.isCountModal = false
    },
    changePurpose(x){
      this.lessonInfo.purpose = x
    },
  }
}
</script>